export type RoleSlug = 'login' | 'student_register' | 'academy_register' | 'academy_status';

export interface RoleLoginTheme {
  slug: RoleSlug;
  label: string;
  kicker: string;
  edKicker: string;
  glyph: string;
  numeral: string;
  titleHtml: string;
  subtitle: string;
  tagline: string;
  taglineSub: string;
  manifest: Array<[string, string]>;
  edition: string;
}

export const ROLE_LOGIN_THEMES: Record<RoleSlug, RoleLoginTheme> = {
  login: {
    slug: 'login',
    label: 'Sign In',
    kicker: 'Paazio · Assess',
    edKicker: 'Assessment Platform',
    glyph: 'Pz',
    numeral: 'Az',
    titleHtml: 'Welcome back<br />to <em>Paazio Assess.</em>',
    subtitle:
      'Sign in to access your quizzes, assessments, and results — everything picked up right where you left it.',
    tagline: 'Measure knowledge. <em>Grow every student.</em>',
    taglineSub:
      'From targeted quizzes to proctored exams — a precision assessment platform built for academies that take results seriously.',
    manifest: [
      ['Platform', 'Paazio Assess'],
      ['Formats', 'Quiz · Exam · Proctored'],
      ['Results', 'Instant · Detailed'],
    ],
    edition: 'Edition · Assess',
  },

  student_register: {
    slug: 'student_register',
    label: 'Student Registration',
    kicker: 'New Student · Enroll',
    edKicker: 'Student Portal',
    glyph: 'St',
    numeral: 'St',
    titleHtml: 'Create your<br /><em>student account.</em>',
    subtitle:
      'Join your academy on Paazio Assess and start taking quizzes, tests, and proctored exams.',
    tagline: 'Test your knowledge. <em>Track your growth.</em>',
    taglineSub:
      'Practice quizzes, live exams, instant feedback — your complete assessment history in one place.',
    manifest: [
      ['Portal', 'Student'],
      ['Modes', 'Practice · Exam · Proctored'],
      ['Results', 'Instant analytics'],
    ],
    edition: 'Edition · Learn',
  },

  academy_register: {
    slug: 'academy_register',
    label: 'Academy Registration',
    kicker: 'Academy · Apply',
    edKicker: 'Institutions Desk',
    glyph: 'Ac',
    numeral: 'Ac',
    titleHtml: 'Register your<br /><em>assessment academy.</em>',
    subtitle:
      'Bring your institution onto Paazio Assess — set up quizzes, batches, and proctored exams in one place.',
    tagline: 'Your academy. <em>Assessment grade.</em>',
    taglineSub:
      'Multi-batch academies, custom question banks, AI proctoring, instant results — everything you need to run serious assessments.',
    manifest: [
      ['Platform', 'Paazio Assess'],
      ['Review', '2–3 business days'],
      ['Support', 'Onboarding included'],
    ],
    edition: 'Edition · Institutions',
  },

  academy_status: {
    slug: 'academy_status',
    label: 'Application Status',
    kicker: 'Academy · Application',
    edKicker: 'Review Desk',
    glyph: 'Rv',
    numeral: 'Rv',
    titleHtml: 'Track your<br /><em>application status.</em>',
    subtitle:
      'Enter your registered email to see where your academy application stands.',
    tagline: 'Your academy is <em>under review.</em>',
    taglineSub:
      'Our team reviews each application carefully. Enter your email to get the latest status on your registration.',
    manifest: [
      ['Desk', 'Applications Review'],
      ['SLA', '2–3 business days'],
      ['Support', 'help@paazio.com'],
    ],
    edition: 'Edition · Review',
  },
};
